import _str from "shared/util/_str";
import makeSmartDateString from "shared/util/makeSmartDateString";

window.FancyDate = {
	defaultformat: "JOURNAL_FORMAT",
	refreshtime: 1000 * 60,
	ids: {},
	list: [],
	maid: null,
	addMany: function(list) {
		list.forEach(this.add.bind(this));
	},
	add: function(id, timestamp, format, params) {
		const element = document.getElementById(id);

		if (!element) {
			return;
		}

		// if the el is already tracked, just update it
		if (this.ids[id]) {
			let i,
				length;
			for (i = 0, length = this.list.length; i < length; i++) {
				if (this.list[i].element === id) {
					this.list[i].time = timestamp;
					this.list[i].format = format;
					this.update(this.list[i]);
					return;
				}
			}
		}
		this.ids[id] = true;

		if (!format || format === "") {
			format = this.defaultformat;
		}

		if (!timestamp) {
			timestamp = new Date();
		} else {
			timestamp = new Date(timestamp * 1000);
		}

		const bundle = {
			element: element,
			time: timestamp,
			format: format,
			output: makeSmartDateString(timestamp, format),
			params: params || {},
		};

		this.list.push(bundle);
		this.update(bundle);
		this.monitor();

		return bundle;
	},
	monitor: function() {
		if (this.maid) { return; }
		const _this = this;
		this.maid = setTimeout(() => { _this.updateAll(); }, this.refreshtime);
	},
	update: function(item) {
		if (!item || !item.element || !item.time) { return false; }

		let str = makeSmartDateString(item.time, item.format);

		if (item.params && item.params.capitalize) {
			str = str.charAt(0).toUpperCase() + str.slice(1);
		}

		if (str !== item.element.innerHTML) {
			item.element.innerHTML = str;
		}
		return true;
	},
	clear: function() {
		this.list = [];
		clearTimeout(this.maid);
	},
	updateAll: function() {
		if (!this.list.length) {
			clearTimeout(this.maid);
			return;
		}
		let i,
			length,
			_this = this;
		for (length = this.list.length, i = length - 1; i >= 0; i--) {
			if (!this.update(this.list[i])) {
				this.list.splice(i, 1);
			}
		}
		this.maid = setTimeout(() => { _this.updateAll(); }, this.refreshtime);
	},
};



// WEBPACK FOOTER //
// ./src/legacy/DateTime.js